import React from "react";
import "../../styleSheets/blockingPageLoader.css";

type BlockingPageLoaderProps = {
  message: string;
};

function BlockingPageLoader({ message }: BlockingPageLoaderProps) {
  return (
    <div
      className="blocking-page-loader"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="blocking-page-loader__card">
        <div className="blocking-page-loader__spinner" aria-hidden="true" />
        <div className="blocking-page-loader__message">{message}</div>
      </div>
    </div>
  );
}

export default BlockingPageLoader;
